var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApple(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0329 7.39822C10.0266 6.25114 10.5558 5.38535 11.627 4.74774C11.0276 3.90696 10.1222 3.44438 8.92667 3.35373C7.7949 3.26622 6.55792 4.00073 6.10521 4.00073C5.62699 4.00073 4.53029 3.38499 3.6695 3.38499C1.89054 3.41312 0 4.77587 0 7.54825C0 8.36715 0.153029 9.21313 0.459086 10.0862C0.867163 11.2333 2.34006 14.0463 3.87673 13.9994C4.68013 13.9807 5.24761 13.4399 6.2933 13.4399C7.30712 13.4399 7.83316 13.9994 8.72901 13.9994C10.2784 13.9775 11.6111 11.4208 12 10.2706C9.92136 9.31107 10.0329 7.45761 10.0329 7.39822ZM8.22848 2.26604C9.09883 1.25335 9.01913 0.33131 8.99362 0C8.22529 0.043758 7.33581 0.512593 6.82891 1.09082C6.27099 1.70969 5.94261 2.47545 6.01275 3.33811C6.84485 3.40062 7.60361 2.98179 8.22848 2.26604Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.c676030b.svg";
export { ForwardRef as ReactComponent };